import React, { useEffect, useState } from 'react';
import {
    CircularProgress,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText,
    Radio,
    Typography
} from '@material-ui/core';
import { getAots } from '../api';
import InfoCard from './InfoCard';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { toHumanReadableDate } from 'helpers/date';

const Aot = ({ market, selectedMerchants, merchantCount, selectedAot, setSelectedAot }) => {
    const [aots, setAots] = useState([]);
    const [loading, setLoading] = useState(true);

    const getData = () => {
        getAots()
            .then(res => setAots(res.data.filter(a => a.deleted_at === null)))
            .catch(err => alert(err))
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (loading) {
            getData();
        }
    }, [loading]);

    return (
        <Grid
            container
            direction="row"
            alignContent="center"
            justify="center"
            justifyContent="center"
            alignItems="center"
            spacing={2}>
            <Grid item xs={12}>
                <InfoCard
                    market={market}
                    merchants={selectedMerchants}
                    merchantCount={merchantCount}
                />
            </Grid>
            {loading ? (
                <CircularProgress size={35} style={{ margin: 20 }} />
            ) : (
                <Grid item xs={12}>
                    <List dense>
                        {aots.map(aot => (
                            <ListItem
                                key={aot.id}
                                button
                                divider
                                dense
                                onClick={() => setSelectedAot(aot)}>
                                <ListItemAvatar style={{ minWidth: 40 }}>
                                    <AssignmentIcon
                                        color={selectedAot?.id === aot.id ? 'primary' : 'inherit'}
                                    />
                                </ListItemAvatar>
                                <ListItemText
                                    id={aot.id}
                                    primary={<Typography variant="body1">{aot.label}</Typography>}
                                    secondary={
                                        <Typography variant="body2">
                                            Dernière mis à jour{' '}
                                            {toHumanReadableDate(aot.updated_at.date)}
                                        </Typography>
                                    }
                                />
                                <ListItemSecondaryAction>
                                    <Radio
                                        edge="end"
                                        onChange={() => setSelectedAot(aot)}
                                        checked={selectedAot?.id === aot.id}
                                        inputProps={{ 'aria-labelledby': aot.id }}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                        ))}
                    </List>
                </Grid>
            )}
        </Grid>
    );
};

export default Aot;
